export const blogCategories = [
  // { label: "Artificial Intelligence", value: "artificial-intelligence" },
  // { label: "Blockchain", value: "blockchain" },
  // { label: "Cloud Computing", value: "cloud-computing" },
  // { label: "Developer Journey", value: "developer-journey" },
  // { label: "Metaverse", value: "metaverse" },
  // { label: "Press", value: "press" },
  // { label: "Case Studies", value: "case-studies" },
  // { label: "Remote", value: "remote" },
  // { label: "Remote Hiring", value: "remote-hiring" },
  // { label: "Remote Leadership", value: "remote-leadership" },
  // { label: "Remote Work", value: "remote-work" },
  // { label: "Staff Augmentation", value: "staff-augmentation" },
  // { label: "Technical", value: "technical" },
  // { label: "Trends/Insight", value: "trends-insight" },
  // { label: "UI-UX", value: "ui-ux" }

  { label: "Artificial Intelligence", value: "artificial-intelligence" },
  { label: "Blockchain", value: "blockchain" },
  { label: "Cloud Computing", value: "cloud-computing" },
  { label: "Developer Journey", value: "developer-journey" },
  { label: "Metaverse", value: "metaverse" },
  { label: "Press", value: "press", disabled: true },
  { label: "Case Studies", value: "case-studies", disabled: true },
  { label: "Cyber Security", value: "cyber-security" },
  { label: "Listicle", value: "listicle" },
  { label: "Remote", value: "remote" },
  { label: "Remote Hiring", value: "remote-hiring" },
  { label: "Remote Leadership", value: "remote-leadership" },
  { label: "Remote Work", value: "remote-work" },
  { label: "Staff Augmentation", value: "staff-augmentation" },
  { label: "Technical", value: "technical" },
  { label: "Trends/Insight", value: "trends-insight" },
  { label: "UI-UX", value: "ui-ux" },
  { label: "Web3", value: "web3" },
  { label: "E-Book", value: "eBooks" },
  { label: "Market Reports", value: "reports" },
]


export const getCategoryName = (value) => {
  return blogCategories?.find(e => e?.value === value)?.label || 'Category not found'
}


export const eBookData = {
  category: "eBooks",
  slug: 'eBooks',
  date: 'June 05, 2025',
  title: "Building Exceptional Teams & Amplifying Remote Productivity",
  description: "Learn how to build high-performing teams and amplify remote productivity with expert insights, practical frameworks, and real-world strategies designed to help you lead, scale, and succeed in a distributed work environment.",
  content: `<h3 id="what-youll-discover-in-this-ebook"><b><strong class="lexicalEditor-textBold" style="white-space: pre-wrap;">What You’ll Discover in This eBook</strong></b></h3><p class="lexicalEditor-paragraph" dir="ltr"><span style="white-space: pre-wrap;">In a world where 63% of businesses have adopted hybrid models and 16% are fully remote, your talent strategy can’t afford to be local—or outdated.</span></p><p class="lexicalEditor-paragraph" dir="ltr"><span style="white-space: pre-wrap;">This eBook will guide you through:</span></p><ul class="lexicalEditor-ul"><li value="1" class="lexicalEditor-listItem" dir="ltr"><span style="white-space: pre-wrap;">How global remote hiring boosts innovation and efficiency</span></li><li value="2" class="lexicalEditor-listItem" dir="ltr"><span style="white-space: pre-wrap;">How AI is changing the way the best companies build remote teams</span></li><li value="3" class="lexicalEditor-listItem" dir="ltr"><span style="white-space: pre-wrap;">What tools, methods, and practices actually move the productivity needle</span></li><li value="4" class="lexicalEditor-listItem" dir="ltr"><span style="white-space: pre-wrap;">Cost-saving strategies through remote-first hiring</span></li><li value="5" class="lexicalEditor-listItem" dir="ltr"><span style="white-space: pre-wrap;">Real examples and proven frameworks from companies leading in remote work</span></li></ul><p class="lexicalEditor-paragraph" dir="ltr"><span style="white-space: pre-wrap;">Read this guide to learn how to learn and grow your high-impact remote team. Let's dive in and future-proof your remote workforce.</span></p>`,
  meta: {
    title: "Building Exceptional Teams & Amplifying Remote Productivity",
    description: "Discover proven strategies to build exceptional teams, boost remote productivity, and drive performance across distributed workforces"
  },
  thumbNail: '/images/eBook.png'
}